import { Socket } from "socket.io-client";

import useAuthSockets, {
  type SocketEventListener,
} from "@/composition/shared/sockets/useAuthSocket.ts";
import { useConfigStore } from "@/stores/config.ts";
import useCvdStore from "@/stores/cvd.ts";

let cvdSocket: Socket | null = null;

const useCvDSocket = () => {
  const cvdStore = useCvdStore();
  const configStore = useConfigStore();
  const socketUrlCvd = `${configStore.remoteConfig.cvd_api_base}/pages`;
  const { initializeSocket, addSocketListeners } = useAuthSockets();

  const onCvDPageUpdate = (data: string) => {
    const updatedPages = JSON.parse(data);
    updatedPages.pageIds.forEach((pageId: string) => {
      cvdStore.updatedCvDPageIds.push(pageId);
    });
  };

  const eventListeners: SocketEventListener[] = [
    {
      eventName: "page-update",
      callback: onCvDPageUpdate,
    },
    {
      eventName: "drive-data-update",
      callback: onCvDPageUpdate,
    },
  ];

  /**
   *
   * postpone sending any service level events that need to be digested
   * by the server only after the first authorization-success event
   * is received.
   */

  const handleAuthSuccessCallback = () => {
    cvdSocket?.emit("enable-page-updates");
    cvdSocket?.emit("enable-drive-data-updates");
  };

  const startUpCvdSocket = async (): Promise<Socket | null> => {
    if (cvdSocket && cvdSocket.connected) {
      return cvdSocket;
    }

    cvdSocket = await initializeSocket(socketUrlCvd, handleAuthSuccessCallback);
    addSocketListeners(eventListeners, cvdSocket);

    cvdSocket?.io.on("error", () => {
      cvdSocket?.disconnect();
    });

    return cvdSocket;
  };

  return {
    startUpCvdSocket,
    getSocket: () => cvdSocket,
  };
};

export default useCvDSocket;
